import { AppConfig } from './ConfigService'

export const goToFid = (queryString: string = '') => {
  window.location.href = `${AppConfig.fidUrl}${queryString}`
}

export const openFidTab = () => {
  window.open(AppConfig.fidUrl, '_blank')
}
